import { atom } from 'jotai';
import { EndUser, InboxLoginStatusResponse, Country } from '@idk-web/api';
import { store } from '@/state/store';

export type InboxUser = {
  displayName: string;
  email: string | null;
  hasValidatedEmail: boolean;
  country: Country;
};

export type InboxAuthState =
  | {
      status: 'LOGGED_OUT';
      token: null;
      user: null;
    }
  | {
      status: 'LOGGED_IN';
      token: string;
      user: InboxUser;
    };

const initialState: InboxAuthState = {
  status: 'LOGGED_OUT',
  token: null,
  user: null,
};

export const inboxAuthState = atom<InboxAuthState>(initialState);

export const inboxLoginStatus = atom((get) => get(inboxAuthState).status);

export const inboxUser = atom((get) => get(inboxAuthState).user);

export function setInboxAuthState(state: InboxAuthState): void {
  store.set(inboxAuthState, state);
}

export function logout(): void {
  setInboxAuthState(initialState);
}

export function login(
  payload: Extract<InboxLoginStatusResponse, { status: 'COMPLETED' }>,
): void {
  setInboxAuthState({
    status: 'LOGGED_IN',
    token: payload.token,
    user: {
      displayName: payload.user.displayName,
      email: payload.user.email,
      hasValidatedEmail: payload.user.hasValidatedEmail,
      country: payload.user.country,
    },
  });
}

export function updateUser(user: EndUser): void {
  const state = store.get(inboxAuthState);

  if (state.status === 'LOGGED_OUT') {
    return;
  }

  setInboxAuthState({
    ...state,
    user: {
      email: user.email,
      displayName: user.displayName,
      hasValidatedEmail: user.hasValidatedEmail,
      country: user.country,
    },
  });
}

export default inboxAuthState;
